var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAdminNavOverall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 4.5H6C5.17157 4.5 4.5 5.17157 4.5 6V9C4.5 9.82843 5.17157 10.5 6 10.5H9C9.82843 10.5 10.5 9.82843 10.5 9V6C10.5 5.17157 9.82843 4.5 9 4.5Z",
    stroke: "#000D26",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 4.5H15C14.1716 4.5 13.5 5.17157 13.5 6V9C13.5 9.82843 14.1716 10.5 15 10.5H18C18.8284 10.5 19.5 9.82843 19.5 9V6C19.5 5.17157 18.8284 4.5 18 4.5Z",
    stroke: "#000D26",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 13.5H6C5.17157 13.5 4.5 14.1716 4.5 15V18C4.5 18.8284 5.17157 19.5 6 19.5H9C9.82843 19.5 10.5 18.8284 10.5 18V15C10.5 14.1716 9.82843 13.5 9 13.5Z",
    stroke: "#000D26",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18 13.5H15C14.1716 13.5 13.5 14.1716 13.5 15V18C13.5 18.8284 14.1716 19.5 15 19.5H18C18.8284 19.5 19.5 18.8284 19.5 18V15C19.5 14.1716 18.8284 13.5 18 13.5Z",
    stroke: "#000D26",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminNavOverall);
export default __webpack_public_path__ + "static/media/admin-nav-overall.cffa8a47be64acf990489bbf7ef6fde7.svg";
export { ForwardRef as ReactComponent };